import React from 'react'
import Navbar from '../Navbar/Navbar'
import Hero from '../Hero/Hero'
import AboutUs from '../AboutUs/AboutUs'
import WorkWithUs from '../WorkWithUs/WorkWithUs'
import Services from '../Services/Services'
import Clients from '../Clients/Clients'
import Testimonials from '../Testimonials/Testimonials'
import Contact from '../contactus/Contact'
import Footer from '../Footer/Footer'
import WhyChooseUs from '../Whychooseus/Whychooseus'
import Products from '../Products/Products'


const Home = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <AboutUs />
      <WhyChooseUs />
      <WorkWithUs />
      <Products />
      <Services />
      <Clients />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  )
}

export default Home